import classNames from "classnames";
import type { FormatTags, MessageType } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";
import { getHtmlString } from "@/shared/utils/htmlMarkupGeneration";
import styles from "./Message.module.scss";

export interface MessageProps {
    type: MessageType;
    text: string;
    tags: FormatTags[];
}

const alertTypes = {
    info: "alertInfo",
    warn: "alertWarn",
    err: "alertError",
} as const;

export const Message = ({ type, text, tags }: MessageProps) => (
    <Grid.Container>
        <Grid.Field spanDesktop={12} spanTablet={12} spanMobile={12}>
            <div
                className={classNames("alert", styles.message, alertTypes[type])}
                dangerouslySetInnerHTML={{
                    __html: getHtmlString({
                        message: text,
                        formatTags: tags,
                    }),
                }}
            />
        </Grid.Field>
    </Grid.Container>
);
